var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFieldAllowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.25H9C3.57 23.25 1.25 20.93 1.25 15.5V9.5C1.25 4.07 3.57 1.75 9 1.75H15C20.43 1.75 22.75 4.07 22.75 9.5V15.5C22.75 20.93 20.43 23.25 15 23.25ZM9 3.25C4.39 3.25 2.75 4.89 2.75 9.5V15.5C2.75 20.11 4.39 21.75 9 21.75H15C19.61 21.75 21.25 20.11 21.25 15.5V9.5C21.25 4.89 19.61 3.25 15 3.25H9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.25H2C1.59 13.25 1.25 12.91 1.25 12.5C1.25 12.09 1.59 11.75 2 11.75H22C22.41 11.75 22.75 12.09 22.75 12.5C22.75 12.91 22.41 13.25 22 13.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 22.75C7.84 22.75 7.5 22.41 7.5 22V12.5C7.5 12.09 7.84 11.75 8.25 11.75C8.66 11.75 9 12.09 9 12.5V22C9 22.41 8.66 22.75 8.25 22.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 23.25C15.34 23.25 15 22.91 15 22.5V12.5C15 12.09 15.34 11.75 15.75 11.75C16.16 11.75 16.5 12.09 16.5 12.5V22.5C16.5 22.91 16.16 23.25 15.75 23.25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.25C7.84 13.25 7.5 12.91 7.5 12.5V2.5C7.5 2.09 7.84 1.75 8.25 1.75C8.66 1.75 9 2.09 9 2.5V12.5C9 12.91 8.66 13.25 8.25 13.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.2491C15.34 13.2491 15 12.9091 15 12.4991V3.03906C15 2.62906 15.34 2.28906 15.75 2.28906C16.16 2.28906 16.5 2.62906 16.5 3.03906V12.4991C16.5 12.9091 16.16 13.2491 15.75 13.2491Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFieldAllowIcon);
export default __webpack_public_path__ + "static/media/table-field-allow-icon.d3811465fe6017361672d989d0ca18c9.svg";
export { ForwardRef as ReactComponent };